module.exports = __webpack_public_path__ + "img/49.48eead1f.jpg";